<template>
  <!-- Sidebar component, swap this element with another sidebar if you like -->
  <div class="flex-1 flex flex-col overflow-y-auto">
    <!-- Navigation -->
    <nav class="px-1">
      <div class="mt-2">
        <!-- Secondary navigation -->
        <range-selector />
        <h3
          class="mb-4 text-xs font-semibold text-gray-500 uppercase tracking-wider"
          id="teams-headline"
        >
          {{ $t('message.flow.flowsidebar.base') }}
        </h3>
        <div
          class="mt-1 space-y-1"
          role="group"
          aria-labelledby="teams-headline"
        >
          <template v-for="blueprint in blueprints">
            <a
              :key="blueprint.id"
              v-on:click="$parent.selectBlueprint(blueprint)"
              class="h-10 group flex items-center px-3 py-5 text-sm font-medium text-gray-700 rounded-md hover:text-gray-900 hover:bg-gray-50"
            >
              <span
                v-if="blueprint.id == index"
                class="w-2.5 h-2.5 mr-4 ml-4 bg-yellow-500 rounded-full"
                aria-hidden="true"
              ></span>
              <span
                v-else
                class="w-2.5 h-2.5 mr-4 ml-4 bg-gray-500 rounded-full"
                aria-hidden="true"
              ></span>
              <span class="truncate">
                {{ blueprint.code }}
              </span>
            </a>
          </template>
        </div>
        <div class="w-full items-center">
          <button
            type="button"
            @click="downloadExcel()"
            class="inline-flex items-center mt-4 px-4 py-3 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            {{ $t('message.flow.flowsidebar.descargarexcel') }}
          </button>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import axios from 'axios';
import { getUnixTime } from 'date-fns';
import RangeSelector from '@/components/RangeSelector'
export default {
  name: 'flow-sidebar',
  components: { RangeSelector },
  props: {
    blueprints: Array,
    index: Number
  },
  data() {
    return {};
  },
  computed: {
    range() {
      return { start: this.$store.getters.innerStart, end: this.$store.getters.innerEnd }
    },
  },
  methods: {
    navigate() {
      this.$router.push({ path: `/mtflow/${this.index}` });
    },

    async downloadExcel() {
      let start = getUnixTime(this.range.start)
      let end = getUnixTime(this.range.end)
      const response = await this.$http.get(`flow/xlsx/${this.index}/${start}/${end}`);
      console.log(response.data.url);
      await axios
        .get(response.data.url, { responseType: 'blob' })
        .then(async res => ({
          blob: await new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          }),
          filename: response.data.filename
        }))
        .then(res => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(res.blob);
          link.download = res.filename;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    }
  }
};
</script>
